import NewIssueHeader from "./components/NewIssueHeader";

export default NewIssueHeader;